import { render, staticRenderFns } from "./DashboardAlertScheduler.vue?vue&type=template&id=0c40692b&scoped=true"
import script from "./DashboardAlertScheduler.vue?vue&type=script&lang=js"
export * from "./DashboardAlertScheduler.vue?vue&type=script&lang=js"
import style0 from "./DashboardAlertScheduler.vue?vue&type=style&index=0&id=0c40692b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c40692b",
  null
  
)

export default component.exports